"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMaxCharacters = void 0;
const state_1 = require("../state");
const getMaxCharacters = () => {
    if (state_1.state.values.constants === null) {
        throw new Error("Attempted to create character with no constants.");
    }
    return state_1.state.values.isSubscribed
        ? state_1.state.values.constants["subscriber-character-slots"]
        : state_1.state.values.constants["free-character-slots"];
};
exports.getMaxCharacters = getMaxCharacters;
